import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import TableDocument from "../../TableDocument";
import { api, get } from "../../../../utils/api";
import FilterModal from "../../../../Components/Common/FilterModal";
import TopMenu from "../../TopMenu";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";

const TransportationDocuments = () => {
  const { user } = useUser();

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [NaturalDoc, SetNaturalDoc] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedOption, setSelectedOption] = useState("Road Transportation");
  const [url, setUrl] = useState("road");
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const [roadFilter, setRoadFilter] = useState({
    origin: "",
    destination: "",
  });
  const [railFilter, setRailFilter] = useState({
    origin: "",
    destination: "",
  });
  const [airFilter, setAirFilter] = useState({
    origin: "",
    destination: "",
  });
  const [shipFilter, setShipFilter] = useState({
    origin: "",
    destination: "",
  });

  useEffect(() => {
    get("/stationaryCombustion/naturalGasDoc")
      .then((res) => {
        SetNaturalDoc(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const fetchData = async (filters = isFiltersApplied ? filterObj : {}) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        facilityList: selectedFacility.join(","),
        page,
        limit: 10,
        search: searchQuery,
      }).toString();
      let apiurl =
        url === "air"
          ? `${api}/scope3/airTransportation/documents?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`
          : url === "rail"
          ? `${api}/scope3/railTransportation/documents?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`
          : url === "water"
          ? `${api}/scope3/shipTransportation/documents?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`
          : `${api}/scope3/roadTransportation/documents?${queryParams}&startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}`;
      const response = await get(apiurl);
      setData(response.data.data);
      setPage(response.data.currentPage);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, url, filterObj, searchQuery, fromDate, toDate, selectedFacility]);

  const heading = [
    {
      title: "Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Consumption Month",
    },
    {
      title: "Assosiated Vendor",
      key: "associatedVendor",
      field: "logisticVendorLegalName",
    },
    {
      title: "Driver",
      key: "driver",
      field: "driverName",
    },
    {
      title: "Source",
      key: "source",
    },
    {
      title: "Destination",
      key: "destination",
    },
    {
      title: "Vehicle",
      key: "vehicle",
      field: "vehicleNumber",
    },
  ].filter(Boolean);

  const railHeading = [
    {
      title: "Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Consumption Month",
    },
    {
      title: "Origin",
      key: "origin",
    },
    {
      title: "Destination",
      key: "destination",
    },
    {
      title: "Freight Load (tonnes)",
      key: "freightLoad",
      field: "value",
    },
  ].filter(Boolean);

  const waterHeading = [
    {
      title: "Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Consumption Month",
    },
    {
      title: "Origin",
      key: "origin",
    },
    {
      title: "Destination",
      key: "destination",
    },
    {
      title: "Shipment Category",
      key: "categoryOfShipment",
    },
    {
      title: "Shipment Type",
      key: "typeOfShipment",
    },
    {
      title: "Freight Load (tonnes)",
      key: "freightLoad.value",
    },
  ].filter(Boolean);

  const fetchFilterData = async (endpoint) => {
    return get(endpoint)
      .then((res) => {
        console.log(res?.data);
        return {
          origin: res?.data?.data?.origin,
          destination: res?.data?.data?.destination,
        };
      })
      .catch((err) => {
        console.log(err);
        return { origin: [], destination: [] };
      });
  };

  useEffect(() => {
    Promise.all([
      fetchFilterData("/scope3/roadTransportation/road/filter"),
      fetchFilterData("/scope3/railTransportation/rail/filter"),
      fetchFilterData("/scope3/airTransportation/air/filter"),
      fetchFilterData("/scope3/shipTransportation/ship/filter"),
    ]).then(([roadData, railData, airData, shipData]) => {
      setRoadFilter(roadData);
      setRailFilter(railData);
      setAirFilter(airData);
      setShipFilter(shipData);
    });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filterDataRail = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Source",
      type: "option",
      key: "origin",
      value: railFilter.origin ? railFilter.origin : [],
    },
    {
      title: "Destination",
      type: "option",
      key: "destination",
      value: railFilter.destination ? railFilter.destination : [],
    },
    {
      title: "Freight Load (tonnes)",
      type: "limit",
      key: "load",
      value: ["one", "two"],
    },
  ];

  const filterDataRoad = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Source",
      type: "option",
      key: "origin",
      value: roadFilter?.origin ? roadFilter.origin : [],
    },
    {
      title: "Destination",
      type: "option",
      key: "destination",
      value: roadFilter?.destination ? roadFilter.destination : [],
    },
  ];

  const filterDataShip = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Origin",
      type: "option",
      key: "origin",
      value: shipFilter?.origin ? shipFilter.origin : [],
    },
    {
      title: "Destination",
      type: "option",
      key: "destination",
      value: shipFilter?.destination ? shipFilter.destination : [],
    },
    // {
    //   title: "Shipment Category",
    //   type: "option",
    //   key: "categoryOfShipment",
    //   value: ["filterDestination"],
    // },
    // {
    //   title: "Shipment Type",
    //   type: "option",
    //   key: "typeOfShipment",
    //   value: ["filterDestination"],
    // },
    {
      title: "Freight Load (tonnes)",
      type: "limit",
      key: "load",
      value: ["one", "two"],
    },
  ];

  const filterDataAir = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Origin",
      type: "option",
      key: "origin",
      value: airFilter?.origin ? airFilter.origin : [],
    },
    {
      title: "Destination",
      type: "option",
      key: "destination",
      value: airFilter?.destination ? airFilter.destination : [],
    },
    {
      title: "Freight Load (tonnes)",
      type: "limit",
      key: "load",
      value: ["one", "two"],
    },
  ];

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
    setIsFiltersApplied(true);
    console.log("Applied Filters:", newFilterObj);
  };

  console.log("filto", filterObj);

  useEffect(() => {
    setFilterObj({});
    setIsFiltersApplied(false);
  }, [url]);

  const handleToggle = (option, url) => {
    setSelectedOption(option);
    setUrl(url);
  };

  const toggleData = [
    { title: "Road Transportation", url: "road" },
    { title: "Rail Transportation", url: "rail" },
    { title: "Air Transportation", url: "air" },
    { title: "Water Transportation", url: "water" },
  ];

  return (
    <MainDashboardLayout sidebar={<DocumentationSidebar />}>
      {/* <Unauthorized requiredModule="Documentation"> */}
        <TopMenu
          {...{
            setDrawerFilterOpen: setIsFilterModalOpen,
            selectedMonth,
            setSelectedMonth,
            selectedYear,
            setSelectedYear,
            selectedOption,
            handleToggle,
            filterApplied: isFiltersApplied,
            toggleData,
            setSearchQuery,
            fromDate,
            setFromDate,
            toDate,
            setToDate,
            selectedFacility,
            setSelectedFacility,
            width: "9rem",
          }}
          heading={"Transportation and Distribution"}
        />

        <TableDocument
          data={data}
          documnets={["documents"]}
          totalPages={totalPages}
          page={page}
          handleChangePage={handleChangePage}
          headers={
            selectedOption === "Rail Transportation" ||
            selectedOption === "Air Transportation"
              ? railHeading
              : selectedOption === "Water Transportation"
              ? waterHeading
              : selectedOption === "Road Transportation"
              ? heading
              : null
          }
          columnWidth={
            selectedOption === "Rail Transportation" ||
            selectedOption === "Air Transportation"
              ? user?.companyAdmin
                ? "12% 15% 14% 14% 15% 15% 9%"
                : "12% 22% 16% 17% 20% 9%"
              : user?.companyAdmin
              ? "12% 12% 13% 10% 10% 10% 10% 12% 9%"
              : "12% 13% 12% 14% 13% 12% 12% 9%"
          }
        />

        <FilterModal
          isOpen={isFilterModalOpen}
          onClose={() => setIsFilterModalOpen(false)}
          filters={
            url === "rail"
              ? filterDataRail
              : url === "road"
              ? filterDataRoad
              : url === "water"
              ? filterDataShip
              : url === "air"
              ? filterDataAir
              : null
          }
          onFilterChange={handleFilterChange}
          title="Filter"
        />
      {/* </Unauthorized> */}
    </MainDashboardLayout>
  );
};

export default TransportationDocuments;
